import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import { productsByCategory } from 'config/products';
import { useTranslation } from '@wix/wix-i18n-config';
import { ProductCard } from 'components/ProductCard.tsx/ProductCard';
import styles from '../SelectProductsStep.scss';

export const SelectProductsStepPreview: FC = () => {
  const { t } = useTranslation();

  const selectedCategory = useAppStore((state) => state.selectedCategory);
  const selectedProducts = useAppStore((state) => state.selectedProducts);

  const products = selectedProducts
    .map((productId) => productsByCategory[selectedCategory].find((p) => p.id === productId))
    .filter((p) => p !== undefined);

  return (
    <div className={styles.selectProductsStepPreview}>
      <div className={styles.selectProductsStepPreviewContent}>
        {products.length === 0 && <div className={styles.selectProductsStepPreviewContentEmpty} />}
        {products.map((product) => (
          <div key={product.id} className={styles.selectProductsStepPreviewContentItem}>
            <ProductCard
              buyButtonText={t('select-products-step.preview.product-card.button-text')}
              imageUrl={product.imageUrl}
              name={product.name}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
